import { Injectable, inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class SeoService {
  private meta = inject(Meta);

  setRobots(content: string = 'index, follow') {
    if (this.meta.getTag('name="robots"')?.content === content) { return };
    this.meta.updateTag({
      name: 'robots',
      content,
    });
  }

  setNoindex() {
    this.setRobots('noindex, nofollow');
  }

  setIndex() {
    this.setRobots('index, follow');
  }
}